export default __webpack_public_path__ + "static/media/lions_roar.b0e78fa9.png";